import type { MessengerCallViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetCallViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerCallViewSettings>(() => {
    const { suitableNumber, uiSettings } = widgetSettings.value.channels[WebWidgetChannelType.CALL]
    const { title, description, buttonText } = uiSettings.mainScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.CALL],
      suitableNumber,
      title,
      description,
      buttonText,
      showQrCode: uiSettings.showQrCode,
    } satisfies MessengerCallViewSettings
  })
}
